export default "__VITE_ASSET__DwWaRo1X__"